import { graphql } from 'gql';

export const priceListUerForTechPartRatioGql = graphql(`
    query uerPriceListUerForTechPartRatio(
        $skip: Int
        $take: Int
        $contractId: Long!
        $where: PriceListUerRowBaseFilterInput
        $order: [PriceListUerRowBaseSortInput!]
    ) {
        uerPriceListUerForTechPartRatio(
            contractId: $contractId
            order: $order
            skip: $skip
            take: $take
            where: $where
        ) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                chapter
                code
                groupCode
                groupId
                groupName
                id
                justification
                name
                sectionId
                sectionName
                status
                uerClassifier
                unit
                linkStatus
            }
        }
    }
`);
